import { FetchResult, gql } from 'apollo-boost';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const MUTATION = gql`
    mutation NarrativeEnable($uid: String!){
        narrative_enable (uid: $uid) {
            success
        }
    }
`;

export async function narrativeEnable(uid: string): Promise<{ success: boolean }> {
    const result: FetchResult<{ narrative_enable: { success: boolean }}> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: { uid },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.narrative_enable;
}
